import React, {useEffect, useState} from 'react';
import dxDataGrid from 'devextreme/ui/data_grid';
import styles from './index.module.scss';

interface ITableErrorsProps{
    gridId: string;
    showAlerts: boolean;
    paintColumn?: boolean;
    changeStyles?:(value: any) => void;
    checkFunction?:(value: any, item: any) => any;
    checkFunction2?:(value: any, item: any) => any;
}

const ErrorTable: React.FC<ITableErrorsProps> = ({ gridId, showAlerts, paintColumn, changeStyles, checkFunction, checkFunction2 }: ITableErrorsProps) => {
    const [parentGrid, setParentGrid] = useState<dxDataGrid>();    
    const [error, setError] = useState(null);
    const [error2, setError2] = useState(null);

    const validateGridDataErrors = (data:any) => {
        let isError = false, isError2 = false;
        let firstError: string = null;
        if(data && showAlerts){
            changeStyles?.(parentGrid)
            data.forEach((item:any, index: number) => {  
                if(parentGrid !== undefined){  
                    const rowElements = parentGrid.getRowElement(index);
                    if(rowElements !== undefined && item){
                        let columns = parentGrid.getVisibleColumns() || []
                        let { columnIds, message } = checkFunction?.(columns, item) || []
                        let { columnIds2, message2 } = checkFunction2?.(columns, item) || []


                        if((!!columnIds?.length && (message === firstError || !firstError)) || !!columnIds2?.length){    
                            rowElements[0].childNodes.forEach((child:any, i: number) => {
                                if(columnIds?.includes(i)){
                                    if(columns?.[i] && paintColumn) columns[i].cssClass = (styles.tdError);
                                    child.classList.add(styles.tdError);
                                }
                                if(columnIds2?.includes(i)){
                                    if(columns?.[i] && paintColumn) columns[i].cssClass = (styles.tdError);
                                    child.classList.add(styles.tdError);
                                }
                            });
                            if(!!columnIds2?.length){
                                setError2(message2)
                                isError2 = true;
                            }
                            setError(message)
                            isError = true;
                            firstError = message;
                        }else{
                            rowElements[0].childNodes.forEach((child:any) => {  
                                child.classList.remove(styles.tdError);
                            });
                        }
                    }
                }  
            })
            if(!isError) setError(null)
            if(!isError2) setError2(null)
        }
    }


    useEffect(()=>{   
        let isApiSubscribed = true;     
        if(parentGrid !== undefined && isApiSubscribed){
            validateGridDataErrors(parentGrid?.getDataSource()?.items());
            parentGrid.option("onCellPrepared",(data:any) => {
                if(isApiSubscribed) validateGridDataErrors(data.component.getDataSource().items())
            });
            parentGrid.option("onOptionChanged", (data: any ) => {
                if(data.name === "dataSource" && isApiSubscribed){
                    validateGridDataErrors(data.component.getDataSource().items());
                }
            })
        }
        return () => { isApiSubscribed = false };
        // eslint-disable-next-line
    },[parentGrid, showAlerts]);


    useEffect(()=>{
        let isApiSubscribed = true;
        if(gridId !== undefined && isApiSubscribed){
            const container = document.getElementById(gridId) as HTMLElement;
            const instance = dxDataGrid.getInstance(container) as dxDataGrid;
            setParentGrid(instance)
        }
        return () => { isApiSubscribed = false };
    },[gridId])
    
    return (
        <>
            <div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"1rem 1rem 0"}}>{error || ''}</h6>
            </div>
            <div style={{width:"100%", textAlign:"center"}}>
                <h6 style={{color:"red", padding:"1rem 1rem 0"}}>{error2 || ''}</h6>
            </div>
        </>
    )
}

export default ErrorTable;